var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSession } from 'next-auth/react';
import Layout from '../components/layout';
import { Button } from 'reactstrap';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as accountServices from '../services/accountServices';
import * as settingServices from '../services/settingServices';
import { pressApplicationCreateUISchema, } from '@ackreditering/viewModels';
import { ContentDisplay } from '../components/contentDisplay';
import Spinner from 'react-bootstrap/Spinner';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import FormLabel from 'react-bootstrap/FormLabel';
import { FormGroup } from 'reactstrap';
import styles from '../../styles/shared.module.css';
import { useRouter } from 'next/router';
import { FormattedMessage, useIntl } from 'react-intl';
import { CountryDropdown } from 'react-country-region-selector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
export default function ApplyPressForm() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    const { data: session } = useSession();
    const router = useRouter();
    const intl = useIntl();
    const { register, handleSubmit, setValue, control, formState: { errors, isSubmitting }, } = useForm({
        mode: 'onChange',
        resolver: zodResolver(pressApplicationCreateUISchema),
    });
    const [existingAccount, setExistingAccount] = useState(false);
    const [isOpen, setIsOpen] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState({
        isError: false,
        message: '',
    });
    const resetMessage = () => {
        setMessage({
            isError: false,
            message: '',
        });
    };
    const showMessageForShortPeriod = (message, numberMilliseconds = 3000) => {
        setMessage(message);
        if (numberMilliseconds) {
            setTimeout(() => {
                resetMessage();
            }, numberMilliseconds);
        }
    };
    const refreshAccountInfo = () => __awaiter(this, void 0, void 0, function* () {
        var _8, _9, _10, _11, _12;
        if ((_8 = session === null || session === void 0 ? void 0 : session.user) === null || _8 === void 0 ? void 0 : _8.id) {
            const accountResult = yield accountServices.getAccount(session.user.id, (e) => console.log(e));
            if (accountResult.success && accountResult.data) {
                const account = accountResult.data;
                setValue('firstName', account.firstName);
                setValue('lastName', account.lastName);
                setValue('email', account.email);
                setValue('password', '');
                setValue('passwordValidation', '');
                setValue('phoneNumber', (_9 = account.phoneNumber) !== null && _9 !== void 0 ? _9 : '');
                setValue('address', account.address);
                setValue('postalCode', account.postalCode);
                setValue('city', account.city);
                setValue('country', (_10 = account.country) !== null && _10 !== void 0 ? _10 : '');
                setValue('personalIdentificationNumber', (_11 = account.personalIdentificationNumber) !== null && _11 !== void 0 ? _11 : '');
                setValue('existingAccount', !!((_12 = session === null || session === void 0 ? void 0 : session.user) === null || _12 === void 0 ? void 0 : _12.id));
                setExistingAccount(true);
            }
            else {
                setExistingAccount(false);
                console.log(accountResult);
            }
        }
    });
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            const initPromises = refreshAccountInfo();
            const fetchSettingPromise = settingServices.getSettingValue({ key: 'Generic', languageCode: null }, (e) => console.log('Error getting Generic setting', e));
            const timeoutPromise = new Promise((resolve) => setTimeout(() => resolve(null), 3000));
            try {
                const [_, genericSetting] = yield Promise.all([
                    initPromises,
                    Promise.race([fetchSettingPromise, timeoutPromise]),
                ]);
                if (genericSetting) {
                    setIsOpen(!!genericSetting.pressOpenForApplications);
                }
                else {
                    setIsOpen(true);
                }
            }
            catch (e) {
                setIsOpen(true);
            }
            finally {
                setIsLoading(false);
            }
        }))();
    }, [session]);
    const registerAndSendApplication = (application) => __awaiter(this, void 0, void 0, function* () {
        var _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26;
        console.log('Form:', application);
        let userId = (_13 = session === null || session === void 0 ? void 0 : session.user) === null || _13 === void 0 ? void 0 : _13.id;
        if ((_14 = session === null || session === void 0 ? void 0 : session.user) === null || _14 === void 0 ? void 0 : _14.id) {
            // Update an existing account
            if (application.password) {
                const passwordResult = yield accountServices.changeAccountPassword({
                    accountId: userId,
                    password: (_15 = application.oldPassword) !== null && _15 !== void 0 ? _15 : '',
                    newPassword: application.password,
                }, (e) => console.log(e));
                if (!passwordResult.success) {
                    showMessageForShortPeriod({
                        message: intl.formatMessage({
                            id: 'user.registration.form.error.failed.to.update',
                        }),
                        isError: true,
                    });
                    return;
                }
            }
            const updateResult = yield accountServices.updateAccount({
                id: userId,
                firstName: application.firstName,
                lastName: application.lastName,
                name: `${application.firstName} ${application.lastName}`,
                phoneNumber: application.phoneNumber,
                address: application.address,
                postalCode: (_16 = application.postalCode) !== null && _16 !== void 0 ? _16 : undefined,
                city: (_17 = application.city) !== null && _17 !== void 0 ? _17 : undefined,
                country: (_18 = application.country) !== null && _18 !== void 0 ? _18 : undefined,
                personalIdentificationNumber: (_19 = application.personalIdentificationNumber) !== null && _19 !== void 0 ? _19 : undefined,
            }, (e) => console.log(e));
            if (!updateResult.success) {
                showMessageForShortPeriod({
                    message: intl.formatMessage({
                        id: 'user.registration.form.error.failed.to.update',
                    }),
                    isError: true,
                });
                return;
            }
        }
        else {
            // Register new account or use existing.
            const createResult = yield accountServices.createAccount({
                firstName: application.firstName,
                lastName: application.lastName,
                email: application.email,
                password: application.password,
                phoneNumber: application.phoneNumber,
                address: application.address,
                postalCode: (_20 = application.postalCode) !== null && _20 !== void 0 ? _20 : undefined,
                city: (_21 = application.city) !== null && _21 !== void 0 ? _21 : undefined,
                country: (_22 = application.country) !== null && _22 !== void 0 ? _22 : undefined,
                gdprAccept: application.gdprConsent,
                personalIdentificationNumber: (_23 = application.personalIdentificationNumber) !== null && _23 !== void 0 ? _23 : undefined,
                reportSuccessIfExistingAccount: true,
            }, (e) => console.log(e));
            if (!createResult.success) {
                showMessageForShortPeriod({
                    message: intl.formatMessage({
                        id: 'user.registration.form.error.failed.to.register',
                    }),
                    isError: true,
                });
                return;
            }
            userId = createResult.id;
        }
        const result = yield accountServices.applyPress(userId, {
            langCode: (_25 = (_24 = router.locale) === null || _24 === void 0 ? void 0 : _24.substring(0, 2)) !== null && _25 !== void 0 ? _25 : 'en',
            pressApplication: application,
        }, (e) => console.log('Error applying for press admission!', e));
        const messageToShow = result.success
            ? 'application.successfully.sent'
            : (_26 = result.errorMessageCode) !== null && _26 !== void 0 ? _26 : 'application.failed.to.send';
        showMessageForShortPeriod({
            isError: !result.success,
            message: intl.formatMessage({ id: messageToShow }),
        });
        if (result.success) {
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                yield router.push(`/`);
            }), 4000);
        }
    });
    const langCode = (_b = (_a = router.locale) === null || _a === void 0 ? void 0 : _a.substring(0, 2)) !== null && _b !== void 0 ? _b : 'en';
    if (isLoading) {
        return (<Layout>
        <Container className="text-center mt-5">
          <Spinner animation="border" role="status"/>
        </Container>
      </Layout>);
    }
    if (!isOpen) {
        return (<Layout>
        <Container>
          <h1>
            <FormattedMessage id={'press.application.form.title'}/>
          </h1>
          <ContentDisplay contentKey={'press application not open reason'} languageCode={langCode}/>
        </Container>
      </Layout>);
    }
    return (<Layout>
      <Container>
        <h1>
          <FormattedMessage id={'press.application.form.title'}/>
        </h1>
        <form onSubmit={handleSubmit(registerAndSendApplication)}>
          <Row className={styles.niceBorder} style={{ paddingTop: '5px' }}>
            <Col md={6} sm={12}>
              <Row>
                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.firstName'}/>
                    :
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <input type={'text'} id={'firstName'} readOnly={isSubmitting} {...register('firstName')} className={styles.niceInput} style={{ width: '100%' }}/>
                  {errors.firstName && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_d = (_c = errors.firstName) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : ' '}/>
                    </div>)}
                </Col>
                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.lastName'}/>:
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <input type={'text'} id={'lastName'} readOnly={isSubmitting} {...register('lastName')} className={styles.niceInput} style={{ width: '100%' }}/>
                  {errors.lastName && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_f = (_e = errors.lastName) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : ' '}/>
                    </div>)}
                </Col>

                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.email'}/>:
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <input type={'email'} id={'email'} readOnly={existingAccount || isSubmitting} {...register('email')} className={styles.niceInput} style={{ width: '100%' }}/>
                  {errors.email && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_h = (_g = errors.email) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : ' '}/>
                    </div>)}
                </Col>

                {existingAccount && (<>
                    <Col md={4}>
                      <FormLabel component="legend">
                        <FormattedMessage id={'user.registration.form.oldPassword'}/>
                        :{' '}
                      </FormLabel>
                    </Col>
                    <Col md={8}>
                      <input type={'password'} id={'oldPassword'} readOnly={isSubmitting} {...register('oldPassword')} className={styles.niceInput} style={{ width: '100%' }}/>
                      {errors.oldPassword && (<div style={{
                    width: '100%',
                    marginTop: '0.25rem',
                    fontSize: '.875em',
                    color: '#dc3545',
                }}>
                          <FormattedMessage id={(_k = (_j = errors.oldPassword) === null || _j === void 0 ? void 0 : _j.message) !== null && _k !== void 0 ? _k : ' '}/>
                        </div>)}
                    </Col>
                  </>)}
                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.password'}/>:{' '}
                    <FontAwesomeIcon titleId={'passwordHint'} icon={faCircleInfo} title={intl.formatMessage({
            id: 'user.registration.form.password.criteria.hint',
        })}/>
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <input type={'password'} id={'password'} readOnly={isSubmitting} {...register('password')} className={styles.niceInput} style={{ width: '100%' }}/>
                  {existingAccount && (<div style={{
                width: '100%',
                fontSize: '.875em',
                color: '#5e5e5e',
            }}>
                      <FormattedMessage id={'user.registration.form.password.empty.info'}/>
                    </div>)}
                  {errors.password && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_m = (_l = errors.password) === null || _l === void 0 ? void 0 : _l.message) !== null && _m !== void 0 ? _m : ' '}/>
                    </div>)}
                </Col>
                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.passwordValidation'}/>
                    :
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <input type={'password'} id={'passwordValidation'} readOnly={isSubmitting} {...register('passwordValidation')} className={styles.niceInput} style={{ width: '100%' }}/>
                  {errors.passwordValidation && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_p = (_o = errors.passwordValidation) === null || _o === void 0 ? void 0 : _o.message) !== null && _p !== void 0 ? _p : ' '}/>
                    </div>)}
                </Col>
              </Row>
            </Col>
            <Col md={6} sm={12}>
              <Col md={4}>
                <FormLabel component="legend">
                  <FormattedMessage id={'user.registration.form.personalIdentificationNumber'}/>
                  :
                </FormLabel>
              </Col>
              <Col md={8}>
                <input type={'text'} id={'personalIdentificationNumber'} {...register('personalIdentificationNumber')} className={styles.niceInput} style={{ width: '100%' }}/>
                {errors.personalIdentificationNumber && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                    <FormattedMessage id={(_r = (_q = errors.personalIdentificationNumber) === null || _q === void 0 ? void 0 : _q.message) !== null && _r !== void 0 ? _r : ' '}/>
                  </div>)}
              </Col>
              <Row>
                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.phoneNumber'}/>
                    :
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <input type={'text'} id={'phoneNumber'} readOnly={isSubmitting} {...register('phoneNumber')} className={styles.niceInput} style={{ width: '100%' }}/>
                  {errors.phoneNumber && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_t = (_s = errors.phoneNumber) === null || _s === void 0 ? void 0 : _s.message) !== null && _t !== void 0 ? _t : ' '}/>
                    </div>)}
                </Col>
                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.address'}/>:
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <input type={'text'} id={'address'} readOnly={isSubmitting} {...register('address')} className={styles.niceInput} style={{ width: '100%' }}/>
                  {errors.address && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_v = (_u = errors.address) === null || _u === void 0 ? void 0 : _u.message) !== null && _v !== void 0 ? _v : ' '}/>
                    </div>)}
                </Col>
                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.postalCode'}/>
                    :
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <input type={'text'} id={'postalCode'} readOnly={isSubmitting} {...register('postalCode')} className={styles.niceInput} style={{ width: '100%' }}/>
                  {errors.postalCode && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_x = (_w = errors.postalCode) === null || _w === void 0 ? void 0 : _w.message) !== null && _x !== void 0 ? _x : ' '}/>
                    </div>)}
                </Col>
                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.city'}/>:
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <input type={'text'} id={'city'} readOnly={isSubmitting} {...register('city')} className={styles.niceInput} style={{ width: '100%' }}/>
                  {errors.city && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_z = (_y = errors.city) === null || _y === void 0 ? void 0 : _y.message) !== null && _z !== void 0 ? _z : ' '}/>
                    </div>)}
                </Col>
                <Col md={4}>
                  <FormLabel component="legend">
                    <FormattedMessage id={'user.registration.form.country'}/>:
                  </FormLabel>
                </Col>
                <Col md={8}>
                  <Controller name="country" render={({ field: { name, onChange, value } }) => (<CountryDropdown defaultOptionLabel={intl.formatMessage({
                id: 'user.registration.form.country.placeholder',
            })} id={'countrySelect'} disabled={isSubmitting} name={name} value={value !== null && value !== void 0 ? value : ''} onChange={onChange}/>)} control={control}/>
                  {errors.country && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                      <FormattedMessage id={(_1 = (_0 = errors.country) === null || _0 === void 0 ? void 0 : _0.message) !== null && _1 !== void 0 ? _1 : ' '}/>
                    </div>)}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <FormGroup>
                <label htmlFor="{'writingFor'}">
                  <FormattedMessage id={'press.application.form.writingFor'}/>
                </label>
                <textarea id={'writingFor'} readOnly={isSubmitting} {...register('writingFor')} className={styles.niceInput} style={{ width: '100%' }}/>
                {errors.writingFor && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                    <FormattedMessage id={(_3 = (_2 = errors.writingFor) === null || _2 === void 0 ? void 0 : _2.message) !== null && _3 !== void 0 ? _3 : ' '}/>
                  </div>)}
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup className={'form-check'}>
                <Form.Check isInvalid={!!errors.gdprConsent} id={'gdprConsent'} readOnly={isSubmitting} {...register('gdprConsent')}/>
                <label htmlFor="gdprConsent">
                  <FormattedMessage id={'press.application.form.read.gdpr.policy'}/>
                </label>
                {errors.gdprConsent && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                    <FormattedMessage id={(_5 = (_4 = errors.gdprConsent) === null || _4 === void 0 ? void 0 : _4.message) !== null && _5 !== void 0 ? _5 : ' '}/>
                  </div>)}
                <p className={'finePrint'}>
                  <a href={'/gdpr-policy'}>
                    <FormattedMessage id={'press.application.form.read.gdpr.policy.link.text'}/>
                  </a>
                </p>
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup>
                <label htmlFor="{'additionalInfo'}">
                  <FormattedMessage id={'press.application.form.additional.info'}/>
                </label>
                <textarea id={'additionalInfo'} readOnly={isSubmitting} {...register('additionalInfo')} className={styles.niceInput} style={{ width: '100%' }}/>
                {errors.additionalInfo && (<div style={{
                width: '100%',
                marginTop: '0.25rem',
                fontSize: '.875em',
                color: '#dc3545',
            }}>
                    <FormattedMessage id={(_7 = (_6 = errors.additionalInfo) === null || _6 === void 0 ? void 0 : _6.message) !== null && _7 !== void 0 ? _7 : ' '}/>
                  </div>)}
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              {(message === null || message === void 0 ? void 0 : message.message) && !message.isError && (<div className={styles.messageDisplay}>{message.message}</div>)}
              {(message === null || message === void 0 ? void 0 : message.message) && message.isError && (<div className={styles.errorDisplay}>{message.message}</div>)}
              <Button variant="primary" type="submit">
                <FormattedMessage id={'press.application.form.send'}/>
              </Button>
            </Col>
          </Row>
        </form>
      </Container>
    </Layout>);
}
